var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperiencePaths(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H21V21H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6281 16.2627C11.6281 14.0327 9.80776 12.2124 7.57782 12.2124H6.11685C6.11472 11.7569 6.11197 11.1871 6.10844 10.4692L2.21191 13.3403L6.10737 16.2114C6.10795 15.2655 6.10975 14.7539 6.11197 14.4682H7.57782C8.56249 14.4682 9.37226 15.278 9.37226 16.2627V20.5898H11.6281V4.31518L13.3713 4.30657L10.5002 0.410086L7.62909 4.30555L9.37226 4.30657V12.5487",
    stroke: "#3B6CAB",
    strokeWidth: 0.820312,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6584 7.82719C12.1921 7.56727 12.7908 7.42117 13.4224 7.42117H14.8834C14.8855 6.96578 14.8882 6.39595 14.8918 5.67801L18.7883 8.5491L14.8928 11.4202C14.8923 10.4744 14.8904 9.96267 14.8882 9.67707H13.4224C12.4377 9.67707 11.6279 10.4868 11.6279 11.4715",
    stroke: "#3B6CAB",
    strokeWidth: 0.820312,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencePaths);
export default __webpack_public_path__ + "static/media/experience-paths.f6b8b9e60d9ff476a2d4ef904537540e.svg";
export { ForwardRef as ReactComponent };